var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.deviceItems),function(item,idx){return _c('div',{key:idx,staticClass:"deviceStatusdiv"},[_c('div',{staticClass:"deviceitemname"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"deviceitem",class:{
        deviceStatus: true,
        'deviceStatus-error': _vm.checkactionerror(item),
        'deviceStatus-success': _vm.checkactionsuccess(item),
        'deviceStatus-defult': _vm.checkactiondefult(item),
      },attrs:{"title":item.title}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }